<form [formGroup]="form">
  <table
  *ngIf="!invisible && documentationItems.length > 0"
    mat-table
    [dataSource]="documentationItemsDataSource"
    formArrayName="DocumentationItems"
  >
    <ng-container matColumnDef="name">
      <th class="val-cell" mat-header-cell *matHeaderCellDef>Nombre</th>
      <td
        class="val-cell"
        mat-cell
        *matCellDef="let row; let index = index"
        [formGroupName]="index"
      >
        <div>
          <b>{{ displayName(index) }}</b>
          <p>{{ displayDescription(index) }}</p>
        </div>
      </td>
    </ng-container>


    <ng-container matColumnDef="carryPatient">
      <th class="val-cell" mat-header-cell *matHeaderCellDef>Trajo paciente</th>
      <td
        class="val-cell"
        mat-cell
        *matCellDef="let row; let index = index"
        [formGroupName]="index"
      >
        <div>
          <mat-checkbox formControlName="CarryPatient"></mat-checkbox>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="info">
      <th class="val-cell" mat-header-cell *matHeaderCellDef></th>
      <td
        class="val-cell"
        mat-cell
        *matCellDef="let row; let index = index"
        [formGroupName]="index"
      >
        <div>
          <mat-form-field>
            <input placeholder="Valor" matInput formControlName="Info" />
          </mat-form-field>
        </div>
      </td>
    </ng-container>

    <!-- Star Column -->
    <ng-container matColumnDef="star" stickyEnd>
      <th
        class="val-cell"
        style="width: 1px"
        mat-header-cell
        *matHeaderCellDef
      ></th>
      <td
        class="val-cell"
        style="width: 1px"
        mat-cell
        *matCellDef="let element"
      ></td>
    </ng-container>
    <tr
      class="val-cell"
      mat-header-row
      *matHeaderRowDef="displayDocumentationItemsColumns; sticky: true"
    ></tr>
    <tr
      class="val-cell"
      mat-row
      *matRowDef="let row; columns: displayDocumentationItemsColumns"
    ></tr>
  </table>
</form>
